// extracted by mini-css-extract-plugin
module.exports = {"back":"style_back__3okOj","flex":"style_flex__1EqXr","topLeft":"style_topLeft__1-ndI"};